import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Navegacion from "../components/BarraNavegacion";
import Footer from "../components/Footer";
import "bootstrap-icons/font/bootstrap-icons.css";
import {
  Col,
  Container,
  Row,
  Form,
  Button,
  Card,
  Figure,
  InputGroup,
} from "react-bootstrap";
import Swal from "sweetalert2";
import PSElogo from "../Assets/pagos-pse-logo-1024x325.webp";
import { db } from "../firebase-config";
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://us-central1-app-sorteos-d43d4.cloudfunctions.net/api";
const SPECIAL_NUMBER_EMAIL = (
  process.env.REACT_APP_SPECIAL_NUMBER_EMAIL || ""
).toLowerCase();
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^[0-9+\-\s()]{7,30}$/;

function validarCorreo(correo) {
  return EMAIL_REGEX.test(String(correo || "").trim().toLowerCase());
}

function CompraSegura() {
  const { cantidad } = useParams();
  const location = useLocation();
  const valor = location.state?.valor_unit || location.state?.price;
  const articulo = location.state?.titulo || location.state?.articulo;

  const [isProcessing, setIsProcessing] = useState(false);
  const [Nombres, setNombres] = useState("");
  const [Apellidos, setApellidos] = useState("");
  const [Telefono, setTelefono] = useState("");
  const [UsuarioIG, setUsuarioIG] = useState("");
  const [Correo, setCorreo] = useState("");
  const [Ciudad, setCiudad] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [ConfirmarCorreo, setConfirmarCorreo] = useState("");
  const [numeroEspecial, setNumeroEspecial] = useState("");


  useEffect(() => {
    const correoNormalizado = Correo.trim().toLowerCase();
    const esCorreoValido = validarCorreo(correoNormalizado);
    const esConfirmacionValida =
      correoNormalizado === ConfirmarCorreo.trim().toLowerCase();
    const esValido =
      Nombres.trim() !== "" &&
      Apellidos.trim() !== "" &&
      PHONE_REGEX.test(Telefono.trim()) &&
      UsuarioIG.trim() !== "" &&
      Ciudad.trim() !== "" &&
      isChecked &&
      esCorreoValido &&
      esConfirmacionValida;

    setIsFormValid(esValido);
  }, [
    Nombres,
    Apellidos,
    Telefono,
    UsuarioIG,
    Ciudad,
    isChecked,
    Correo,
    ConfirmarCorreo,
  ]);

  const crearTransactionId = () => {
    if (window.crypto?.randomUUID) {
      return `pedido_${window.crypto.randomUUID()}`;
    }

    return `pedido_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  };

  const handleInputChange = (setter, value) => {
    setter(value);
  };

  const handleCheckoutMercadoPago = async () => {
    setIsProcessing(true);

    try {
      const transactionId = crearTransactionId();
      const cantidadNumerica = Number(cantidad);

      const ultimoSorteo = await obtenerSorteoActivo();
      if (!ultimoSorteo) {
        Swal.fire("Error", "No hay sorteos activos en este momento.", "error");
        setIsProcessing(false);
        return;
      }

      const precioUnitario = Number(ultimoSorteo.price);
      if (
        !Number.isInteger(cantidadNumerica) ||
        cantidadNumerica <= 0 ||
        !Number.isFinite(precioUnitario) ||
        precioUnitario <= 0
      ) {
        Swal.fire("Error", "La informacion de compra no es valida.", "error");
        setIsProcessing(false);
        return;
      }

      const userData = {
        idSorteo: ultimoSorteo.id,
        cifras: ultimoSorteo.cifras,
        Nombres: sanitizeText(Nombres, 80),
        Apellidos: sanitizeText(Apellidos, 80),
        Telefono: sanitizeText(Telefono, 30),
        Correo: sanitizeText(Correo, 180).toLowerCase(),
        Instagram: sanitizeText(UsuarioIG, 80),
        Ciudad: sanitizeText(Ciudad, 80),
        Cantidad: cantidadNumerica,
        Titulo: ultimoSorteo.title || articulo,
        Valor: precioUnitario,
        numeroEspecial:
          SPECIAL_NUMBER_EMAIL &&
          Correo.trim().toLowerCase() === SPECIAL_NUMBER_EMAIL
            ? numeroEspecial.replace(/\D/g, "")
            : "",

      };
      // Llamar a la función de Firebase para obtener el `init_point`
      const response = await fetch(`${API_BASE_URL}/crear-preferencia`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...userData,
          articulo: userData.Titulo,
          valor: precioUnitario,
          cantidad: cantidadNumerica,
          idSorteo: ultimoSorteo.id,
          transactionId,
        }),
      });

      const result = await parseJsonResponse(response);

      if (!response.ok) {
        throw new Error(result.error || "No se pudo crear la transaccion.");
      }

      if (result.success && isSafeRedirectUrl(result.init_point)) {
        localStorage.setItem("transactionId", transactionId);
        window.location.href = result.init_point;
      } else {
        throw new Error(result.error || "No se pudo iniciar el pago.");
      }
    } catch (err) {
      console.error("Error al procesar pago con Mercado Pago:", err);
      Swal.fire(
        "Error",
        err.message || "No se pudo iniciar el pago.",
        "error"
      );
    } finally {
      setIsProcessing(false);
    }
  };

  async function obtenerSorteoActivo() {
    const sorteosRef = collection(db, "sorteos");
    const q = query(
      sorteosRef,
      where("activo", "==", true),
      orderBy("createdAt", "desc"), // ✅ Usamos tu campo de timestamp
      limit(1)
    );
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const docSnap = querySnapshot.docs[0];
      return {
        id: docSnap.id,
        ...docSnap.data(),
      };
    }

    return null;
  }

  const handleClick = () =>
    Swal.fire({
      html: `
      <h1>Política de Privacidad</h1>
      <p>Tu privacidad es importante para nosotros. Consulta nuestros términos en elchriis.com.</p>
    `,
    });

  return (
    <>
      <Navegacion title="Finalizar compra" />
      <Container>
        <Form>
          <Row>
            <Col lg="6">
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Nombres*"
                  className="mb-3 mt-4"
                  maxLength={80}
                  onChange={(e) =>
                    handleInputChange(setNombres, e.target.value)
                  }
                />
                <Form.Control
                  type="text"
                  placeholder="Apellidos*"
                  className="mb-3"
                  maxLength={80}
                  onChange={(e) =>
                    handleInputChange(setApellidos, e.target.value)
                  }
                />
                <Form.Control
                  type="number"
                  placeholder="Telefono*"
                  className="mb-3"
                  maxLength={30}
                  onChange={(e) =>
                    handleInputChange(setTelefono, e.target.value)
                  }
                />
                <InputGroup className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Usuario de Instagram o Facebook*"
                    aria-label="Usuario de Instagram o Facebook"
                    aria-describedby="basic-addon1"
                    maxLength={80}
                    onChange={(e) =>
                      handleInputChange(setUsuarioIG, e.target.value)
                    }
                  />
                </InputGroup>

                <Form.Control
                  type="email"
                  placeholder="Correo electrónico*"
                  className="mb-1"
                  value={Correo}
                  maxLength={180}
                  onChange={(e) => handleInputChange(setCorreo, e.target.value)}
                  isInvalid={Correo !== "" && !validarCorreo(Correo)}
                />
                <Form.Control.Feedback type="invalid">
                  Ingresa un correo electrónico válido
                </Form.Control.Feedback>

                <Form.Control
                  type="email"
                  placeholder="Confirmar correo electrónico*"
                  className="mb-3 mt-2"
                  value={ConfirmarCorreo}
                  maxLength={180}
                  onChange={(e) =>
                    handleInputChange(setConfirmarCorreo, e.target.value)
                  }
                  isInvalid={
                    ConfirmarCorreo !== "" &&
                    Correo.trim().toLowerCase() !==
                      ConfirmarCorreo.trim().toLowerCase()
                  }
                />
                <Form.Control.Feedback type="invalid">
                  Los correos no coinciden
                </Form.Control.Feedback>

                {SPECIAL_NUMBER_EMAIL &&
                  Correo.trim().toLowerCase() === SPECIAL_NUMBER_EMAIL && (
                  <Form.Control
                    type="text"
                    placeholder="Número especial (opcional)"
                    className="mb-3"
                    value={numeroEspecial}
                    maxLength={6}
                    onChange={(e) =>
                      setNumeroEspecial(e.target.value.replace(/\D/g, ""))
                    }
                  />
                )}
                <Form.Control
                  type="text"
                  placeholder="Ciudad de residencia*"
                  className="mb-3"
                  maxLength={80}
                  onChange={(e) => handleInputChange(setCiudad, e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col lg="6" className="mt-4">
              <Card>
                <Card.Title className="mt-4">Paga seguro con</Card.Title>
                <div className="d-flex justify-content-center">
                  <Card.Img
                    variant="top"
                    src={PSElogo}
                    style={{ width: "18rem" }}
                  />
                </div>
                <Figure>
                  <Figure.Caption className="p-2">
                    Paga fácilmente a través de PSE, Bancolombia, Daviplata,
                    Nequi, entre otros.
                  </Figure.Caption>
                </Figure>
                <Card.Body>
                  <h4>Resumen de tu compra</h4>
                  <Row>
                    <Col lg="4">
                      <h6>Producto</h6>
                    </Col>
                    <Col lg="4">
                      <h6>Cantidad</h6>
                    </Col>
                    <Col lg="4">
                      <h6>Valor unitario</h6>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="4">Stickers x{cantidad}</Col>
                    <Col lg="4">{cantidad}</Col>
                    <Col lg="4">
                      {" "}
                      {Number(valor).toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col lg="6">
                      <h6>Total a pagar</h6>
                    </Col>
                    <Col lg="6">
                      <h6>
                        {" "}
                        {Number(valor * cantidad).toLocaleString("es-CO", {
                          style: "currency",
                          currency: "COP",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}{" "}
                        COP
                      </h6>
                    </Col>
                  </Row>
                  <hr />
                  <h6 className="mt-3">
                    Tus datos personales serán utilizados para procesar tu
                    pedido y otros fines descritos en nuestra{" "}
                    <Button variant="link" onClick={handleClick}>
                      Política de Privacidad
                    </Button>
                  </h6>
                  <div className="mb-3 d-flex justify-content-center">
                    <Form.Check
                      id="Check-Terminos"
                      label="Acepto términos y condiciones."
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                    />
                  </div>

                  {/* ✅ BOTÓN NUEVO DE PAGO CON CHECKOUT */}
                  <Button
                    className="btn btn-dark w-100 mt-3"
                    onClick={handleCheckoutMercadoPago}
                    disabled={!isFormValid}
                  >
                    {isProcessing ? "Procesando..." : "Pagar con Mercado Pago"}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Form>
      </Container>
      <Footer />
    </>
  );
}

function sanitizeText(value, maxLength) {
  return String(value || "")
    .replace(/[\r\n]+/g, " ")
    .trim()
    .slice(0, maxLength);
}

function isSafeRedirectUrl(value) {
  try {
    const url = new URL(value);
    return url.protocol === "https:";
  } catch (error) {
    return false;
  }
}

async function parseJsonResponse(response) {
  try {
    return await response.json();
  } catch (error) {
    return {};
  }
}

export default CompraSegura;
